<template>
  <v-card class="rounded-lg">
    <v-card-title>Runtime custom categories map config</v-card-title>
    <v-toolbar flat color="transparent">
      <v-text-field
        v-model="search"
        :append-icon="mdiMagnify"
        label="Search"
        single-line
        hide-details>
      </v-text-field>
      <v-spacer/>
      <CustomCategoryDialog
        v-model="category"
        :item="editedItem"
        @save="save"
      />
    </v-toolbar>
    <v-data-table
      :headers="headers"
      :items="categories"
      :search="search"
      hide-default-footer
      disable-pagination
    >
      <template v-slot:item.action="{ item }">
        <v-icon
          small
          class="mr-2"
          title="Edit category"
          @click="editItem(item)"
        >
          {{ mdiPencil }}
        </v-icon>
        <v-icon
          v-if="item.status == 'visible'"
          small
          class="mr-2"
          title="Hide category"
          @click="changeItemStatus(item, 'hidden')"
        >
          {{ mdiEye }}
        </v-icon>
        <v-icon
          v-else
          small
          class="mr-2"
          title="Show category"
          @click="changeItemStatus(item, 'visible')"
        >
          {{ mdiEyeOff }}
        </v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mdiPencil, mdiEye, mdiEyeOff, mdiMagnify } from "@mdi/js"
export default {
  components: {
    CustomCategoryDialog: () => import('../../../../components/dialogs/CustomCategoryDialog')
  },
  data() {
    return {
      mdiPencil,
      mdiEye,
      mdiEyeOff,
      mdiMagnify,
      search: '',
      category: false,
      revisions: false,
      categories: [],
      headers: [
        {
          text: 'Alias',
          value: 'alias',
          sortable: false,
        },
        {
          text: 'Table name',
          value: 'table_name',
          sortable: false,
        },
        {
          text: 'Type',
          value: 'type',
          sortable: false,
        },
        {
          text: 'Color',
          value: 'color',
          sortable: false,
        },
        {
          text: 'Actions',
          value: 'action',
          sortable: false,
        },
      ],
      dafultItem: {
        alias: '',
        table_name: '',
        color_type: 'solid',
        color: '#FFFFFF',
        type: 'point',
        status: 'visible',
        colors_config: {
          minCount: 0,
          maxCount: 0,
          colorsByValue: [
            [0, 'integer', '#FFFFFF']
          ]
        },
        columns: []
      },
      editedItem: {
        alias: '',
        table_name: '',
        color_type: 'solid',
        color: '#FFFFFF',
        type: 'point',
        colors_config: {
          minCount: 0,
          maxCount: 0,
          colorsByValue: [
            [0, 'integer', '#FFFFFF']
          ]
        },
        columns: []
      }
    }
  },
  async created() {
    let { data } = await this.$axios.get(this.$store.getters.projectPath + '/configs/runtime-custom-categories/data');
    this.categories = data;
  },
  methods: {
    editItem(item) {
      this.editedIndex = this.categories.indexOf(item);
      this.editedItem = Object.assign({}, { ...item, platforms: { ...this.editedItem.platforms, ...item.platforms }});
      this.category = true;
    },
    async save(item) {
      let { data } = await this.$axios({
        method: item.id ? 'put' : 'post',
        url: this.$store.getters.projectPath + '/configs/runtime-custom-categories' + (item.id ? '/' + item.id : ''),
        data: item
      });
      let index = this.categories.findIndex(category => category.id == data.id);
      if (index !== -1) {
        this.$set(this.categories, index, data);
        this.$toasted.success('Category updated');
      } else {
        this.categories.push(data);
        this.$toasted.success('Category created')
      }
    },
    async changeItemStatus(item, status) {
      try {
        let { data } = await this.$axios.put(
          `${this.$store.getters.projectPath}/configs/runtime-custom-categories/${item.id}/status`,
          { status }
        )
        let index = this.categories.findIndex(category => category.id == data.id);
        if (index !== -1) {
          let category = this.categories.find(category => category.id == data.id);
          this.$set(this.categories, index, { ...category, status });
          this.$toasted.success('Status changed');
        }
      } catch (err) {
        console.log(err);
        this.$toasted.error('Oops. Something went wrong');
      }
    }
  },
  watch: {
    category() {
      if (!this.category) {
        this.$validator.reset();
        this.editedItem = Object.assign({}, { ...this.dafultItem })
      }
    }
  }
}
</script>
